<svg width="48" height="48" viewBox="0 0 48 48" fill="none" xmlns="http://www.w3.org/2000/svg">
<g clip-path="url(#clip0_4524_742)">
<path d="M21.4642 40.0678C19.213 42.1199 16.062 43.397 12.5779 43.397C5.75272 43.397 0.429822 37.0466 0.199436 31.0705C-0.256538 19.1041 23.1901 0.638403 24.1932 0C25.1916 0.638403 48.643 19.1041 48.1871 31.0705C47.9567 37.0466 42.6338 43.397 35.8086 43.397C31.803 43.397 28.233 41.7059 25.9684 39.0888C26.7229 42.203 27.9868 45.2064 29.7283 47.9952H17.9529C19.515 45.5023 20.693 42.8342 21.4642 40.0678Z" fill="url(#paint0_linear_4524_742)"/>
<path d="M29.7283 47.9952L29.7313 48V47.9952H29.7283Z" fill="url(#paint1_linear_4524_742)"/>
<path fill-rule="evenodd" clip-rule="evenodd" d="M32.8418 17.166C33.5425 17.8229 33.578 18.9235 32.9211 19.6242L21.2579 32.065L15.1183 25.9254C14.4391 25.2462 14.4391 24.145 15.1183 23.4659C15.7974 22.7867 16.8986 22.7867 17.5778 23.4659L21.1773 27.0654L30.3836 17.2453C31.0405 16.5446 32.1411 16.5091 32.8418 17.166Z" fill="white"/>
</g>
<defs>
<linearGradient id="paint0_linear_4524_742" x1="24.1933" y1="0" x2="24.1933" y2="48" gradientUnits="userSpaceOnUse">
<stop stop-color="#5BC4FF"/>
<stop offset="1" stop-color="#480D93"/>
</linearGradient>
<linearGradient id="paint1_linear_4524_742" x1="24.1933" y1="0" x2="24.1933" y2="48" gradientUnits="userSpaceOnUse">
<stop stop-color="#5BC4FF"/>
<stop offset="1" stop-color="#480D93"/>
</linearGradient>
<clipPath id="clip0_4524_742">
<rect width="48" height="48" fill="white"/>
</clipPath>
</defs>
</svg>
